import Line from './line.vue';
import { defineComponent, reactive, computed } from '@vue/composition-api';
import status from '@/alas/status';
import moment from 'moment';
export default defineComponent({
    components: {
        'self-line': Line
    },
    props: {
        show: {
            default: () => {
                return {
                    events: true,
                    sunLine: true,
                    rainLine: true,
                    highTempLine: true,
                    lowTempLine: true,
                    priceLine: true,
                    transLine: true,
                    expenditureLine: true,
                    incomeLine: true
                };
            }
        },
        picture: {},
        prevPicture: {},
        nextPicture: {}
    },
    setup($p) {
        let $ = reactive({
            type: status.fetch('types').fetch($p.picture.type),
            showPicture: false
        });
        let getPos = (params) => {
            let cy = 100 - (params.center / params.base * 100);
            let y1 = 100 - (params.start / params.base * 100);
            let y2 = 100 - (params.finish / params.base * 100);
            return {
                cx: 50,
                cy,
                x1: $p.prevPicture == null ? 50 : 0,
                y1: (cy + y1) / 2,
                x2: $p.nextPicture == null ? 50 : 100,
                y2: (cy + y2) / 2,
                unit: params.unit,
                name: params.name,
                value: params.value,
                color: params.color
            };
        };
        let getBaseValue = (base, value) => {
            return 100 - (value / base * 100);
        };
        // ================
        //
        // computed
        //
        let day = computed(() => $p.picture.$v.createdAt);
        let week = computed(() => moment($p.picture.$v.createdAt).day());
        let tags = computed(() => $.type.tags.items.filter(t => $p.picture.tags.includes(t.key)));
        let simpleEvents = computed(() => {
            return $p.picture.eventMessage.items.map(t => {
                return {
                    text: t.simpleText,
                    color: $.type.events.fetch(t.key).color
                };
            });
        });
        let sunLine = computed(() => {
            return getPos({
                name: '日照',
                unit: 'hr',
                base: 14,
                value: $p.picture.weather.sunshine,
                color: 'yellow',
                start: ($p.prevPicture || $p.picture).weather.sunshine,
                center: $p.picture.weather.sunshine,
                finish: ($p.nextPicture || $p.picture).weather.sunshine
            });
        });
        let rainLine = computed(() => {
            return getPos({
                name: '雨量',
                unit: 'mm',
                base: 300,
                value: $p.picture.weather.rain,
                color: 'blue',
                start: ($p.prevPicture || $p.picture).weather.rain,
                center: $p.picture.weather.rain,
                finish: ($p.nextPicture || $p.picture).weather.rain
            });
        });
        let highTempLine = computed(() => {
            return getPos({
                name: '最高溫',
                unit: '°C',
                base: 50,
                value: $p.picture.weather.highTemperature,
                color: 'red',
                start: ($p.prevPicture || $p.picture).weather.highTemperature,
                center: $p.picture.weather.highTemperature,
                finish: ($p.nextPicture || $p.picture).weather.highTemperature
            });
        });
        let lowTempLine = computed(() => {
            return getPos({
                name: '最低溫',
                unit: '°C',
                base: 50,
                value: $p.picture.weather.lowTemperature,
                color: 'aqua',
                start: ($p.prevPicture || $p.picture).weather.lowTemperature,
                center: $p.picture.weather.lowTemperature,
                finish: ($p.nextPicture || $p.picture).weather.lowTemperature
            });
        });
        let priceLine = computed(() => {
            return getPos({
                name: '市場均價',
                unit: '台幣',
                base: $.type.baseLine.price,
                value: Number($p.picture.market.averagePrice.toFixed(1)),
                color: 'forestgreen',
                start: ($p.prevPicture || $p.picture).market.averagePrice,
                center: $p.picture.market.averagePrice,
                finish: ($p.nextPicture || $p.picture).market.averagePrice
            });
        });
        let transLine = computed(() => {
            return getPos({
                name: '市場交易量',
                unit: '臺斤',
                base: $.type.baseLine.trans,
                value: Number($p.picture.market.transactions.toFixed(1)),
                color: 'magenta',
                start: ($p.prevPicture || $p.picture).market.transactions,
                center: $p.picture.market.transactions,
                finish: ($p.nextPicture || $p.picture).market.transactions
            });
        });
        let expenditureLine = computed(() => {
            return getPos({
                name: '支出',
                unit: 'TW',
                base: 10000,
                value: $p.picture.$v.totalExpenditure,
                color: 'magenta',
                start: ($p.prevPicture || $p.picture).$v.totalExpenditure,
                center: $p.picture.$v.totalExpenditure,
                finish: ($p.nextPicture || $p.picture).$v.totalExpenditure
            });
        });
        let incomeLine = computed(() => {
            return getPos({
                name: '收入',
                unit: 'TW',
                base: 10000,
                value: $p.picture.$v.totalIncome,
                color: 'magenta',
                start: ($p.prevPicture || $p.picture).$v.totalIncome,
                center: $p.picture.$v.totalIncome,
                finish: ($p.nextPicture || $p.picture).$v.totalIncome
            });
        });
        return {
            $,
            day,
            week,
            tags,
            sunLine,
            rainLine,
            highTempLine,
            lowTempLine,
            priceLine,
            transLine,
            expenditureLine,
            incomeLine,
            simpleEvents
        };
    }
});
